"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TAG_SIZES = exports.TAG_COLORS = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["children", "className", "color", "element", "href", "icon", "isOnDarkCanvas", "size", "subtle", "text"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TAG_COLORS = ['neutral', 'primary', 'alternate', 'positive', 'negative'];
exports.TAG_COLORS = TAG_COLORS;
var TAG_SIZES = ['small', 'medium', 'large'];
exports.TAG_SIZES = TAG_SIZES;

var getConditionalProps = function getConditionalProps(href) {
  return {
    href: href ? href : null
  };
};

var getElement = function getElement(href, element) {
  return element || (href ? 'a' : 'span');
};

var Tag = function Tag(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      element = _ref.element,
      href = _ref.href,
      TagIcon = _ref.icon,
      isOnDarkCanvas = _ref.isOnDarkCanvas,
      size = _ref.size,
      subtle = _ref.subtle,
      text = _ref.text,
      rest = _objectWithoutProperties(_ref, _excluded);

  var Element = getElement(href, element);
  var tagClasses = (0, _classnames.default)('rds-Tag', (_classNames = {}, _defineProperty(_classNames, "rds-Tag--".concat(color), color !== 'neutral'), _defineProperty(_classNames, "rds-Tag--".concat(size), size !== 'medium'), _defineProperty(_classNames, 'rds-Tag--subtle', subtle), _defineProperty(_classNames, 'on-darkCanvas', isOnDarkCanvas), _classNames), className);
  return /*#__PURE__*/_react.default.createElement(Element, _extends({
    className: tagClasses
  }, getConditionalProps(href), rest), TagIcon && /*#__PURE__*/_react.default.createElement(TagIcon, {
    fill: "currentColor",
    className: "rds-Tag-icon",
    "aria-hidden": true,
    focusable: false
  }), children || text);
};

exports.default = Tag;
Tag.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(TAG_COLORS),
  element: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  href: _propTypes.default.string,
  icon: _propTypes.default.func,
  isOnDarkCanvas: _propTypes.default.bool,
  size: _propTypes.default.string,
  subtle: _propTypes.default.bool,
  text: _propTypes.default.string
};
Tag.defaultProps = {
  className: '',
  color: 'neutral',
  href: null,
  icon: null,
  isOnDarkCanvas: false,
  size: 'medium',
  subtle: false
};
Tag.displayName = 'Tag';